<template>
  <div class="box-second">

    <div class="main">
      <!-- <div class="main-left">
               <el-tree :data="dataTree" ref="tree" :props="defaultProps" @node-click="handleNodeClick" node-key='projectId' highlight-current default-expand-all></el-tree>
           </div> -->
      <div class="main-table qsList" >
        <div class="title-crumb">
          <!-- <el-breadcrumb separator-class="el-icon-arrow-right color3">
            <el-breadcrumb-item>质安管理</el-breadcrumb-item>
            <el-breadcrumb-item v-if="flag==1">我发起的</el-breadcrumb-item>
            <el-breadcrumb-item v-if="flag==2">我未处理</el-breadcrumb-item>
            <el-breadcrumb-item v-if="flag==3">我已处理</el-breadcrumb-item>
          </el-breadcrumb> -->
          <el-button v-for="(item,index) in list" :key="index" :class="{'cur':flag==item.flag}"
            @click="search(item.flag)">
            {{item.name}}
            <div class="round" v-if="item.flag==1">{{dealtCount.wfq}}</div>
            <div class="round" v-if="item.flag==4">{{dealtCount.wcsDcl}}</div>
            <div class="round" v-if="item.flag==3">{{dealtCount.ycl}}</div>
            <div class="round" v-if="item.flag==5">{{dealtCount.csDcl}}</div>
          </el-button>
          <!-- <el-button @click="addFlag" type="text" size="mini" icon="el-icon-circle-plus-outline">
            添加发起
          </el-button> -->
          <p @click="addFlag" style="display: flex;align-items: center;">
            <img style="width: 30px;height:30px;" src="../../assets/image/add.png" alt="">
            <span>添加发起</span>
          </p>
           
        </div>
        <div class="build-table">
          <div class="table-item" v-for="(item,index) in proQsList" :key="index">
            <div class="item-l">
              <img :src="item.pic" style="width:100%;height:100%;" />
              <img v-if="item.form=='2'" class="img-icon" src="../../assets/image/icon/ent_icon.png" style="width:48px;height:48px;" />
            </div>
            <div class="item-mid">
              <p>检查事项：</p>
              <p class="line2" style="height:6vh;" :title="item.description">{{item.description}}</p>
              <p>问题性质:
                <span :class="(item.priority==2?'cur':'')">{{item.priorityName||'无'}}</span>
              </p>
              <p>检查人：{{item.reportName}}</p>
              <p>检查时间：{{item.happenDate}}</p>
            </div>
            <div class="item-mid">
              <p>检查结果：
                <span v-if="item.type!='2'" style="color:#67C23A;">合格</span>
                <span v-else-if="item.status=='3'" style="color:#67C23A;">已整改</span>
                <span v-else style="color:#1ed76d;">待整改</span>
              </p>
              <p>责任人: |{{item.handlerName|'--'}}</p>
              <p>处理状态：{{item. processStatus}}</p>
              <p>地址{{item.address || '--'}}</p>
              <!-- <p>确认人：{{item.affirm || '--'}}</p> -->
              <!-- <p>确认状态：{{item.affirmStatus || '--'}}</p> -->
              <!-- <p>处理信息：{{item.checkStatus || '--'}}</p>
                                   <p>处理状态：{{item.processDesc || '--'}}</p> -->
            </div>
            <div class="item-r">
              <el-button v-if="flag==2" type="text" @click="toDetail(item)">去处理</el-button>
              <el-button v-else type="text" @click="toDetail(item)">详情</el-button>
              <!-- <el-button type="text" @click="toDownFile(item)" style="color:#67C23A;">导出</el-button> -->
            </div>
          </div>
        </div>
        <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
          :current-page="currentPage1" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper" :total="totalItems1"></el-pagination>
      </div>
      <!-- 暂无数据 -->
      <div v-if="isData" class="imgs">
        <!-- <img src="../../assets/image/noData.png" alt=""> -->
        <div>暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
  import myHttp from "../../untils/port.js";
  import util from "../../untils/util.js"
  import base from '../../untils/base'
  export default {
    data() {
      return {
        list: [
          { name: '我发起的', flag: '1' }, { name: '我未处理', flag: '4' }, { name: '我已处理', flag: '3' }, { name: '已超时', flag: '5' }
        ],
        tabIndex: '',
        groupId: '',
        dataTree: [],//左侧班组树形结构
        defaultProps: {
          children: 'list',
          label: 'name'
        },
        activeName: 'first',
        projectId: '',
        //企业分页
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        //项目分页
        currentPage1: 1,
        pageSize1: 10,
        totalItems1: 0,
        proQsList: [],//项目检查
        curId: 0,
        flag: '',
        dealtCount: {
          dcl: 0,
          wfq: 0,
          ycl: 0,
        },
        isData: false,
        types: []
      }
    },
    mounted() {
      this.groupId = util.session.get('groupId')
      this.projectId = this.groupId
      this.flag = this.$route.params.type
      
      this.getData()
      this.getQsDealtCount()
      this.getDictByType()
    },
    methods: {

      //公司分页
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage();
      },
      currentChangePage() {
        this.getData();
      },

      //项目分页
      handleSizeChange1(val) {
        this.pageSize1 = val
        this.handleCurrentChange1(this.currentPage)
      },
      handleCurrentChange1(val) {
        this.currentPage1 = val
        this.currentChangePage1();
      },
      currentChangePage1() {
        this.getData();
      },
      //获取项目检查
      getData() {
        var that = this
        myHttp.getQsDealtPageList({
          projectId: this.projectId,
          userId: util.session.get('user').id,
          flag: this.flag,
          pageNum: this.currentPage1,
          pageSize: this.pageSize1
        }).then(function (resp) {
          console.log(resp,that.flag)
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              for (var j = 0; j < that.types.length; j++) {
                if (list[i].priority == that.types[j].value) {
                  list[i].priorityName = that.types[j].label
                }
              }
              list[i].pic = list[i].picUrls && list[i].picUrls != '' ? base.httpCtx + (list[i].picUrls.split(',')[0]) : require('../../assets/image/project.png')
            }
            that.totalItems1 = resp.data.data.pageInfo.total || 0
            if (list.length == 0) {
              that.isData = true
            } else {
              that.isData = false
            }
            that.proQsList = list

          }
        })
      },
      search(flag) {
        this.flag = flag
        this.getData()
      },
      /**
       * 详情
       */
      toDetail(row) {
        // console.log(row)
        this.$router.push({ name: 'qsDetail', params: { id: row.id, type: this.flag, handle: '2' } })
      },
      /**
       * 下载
       */
      toDownFile(row) {
        var token = util.session.get('token')
        window.open(
          myHttp.exportQsInfo +
          '?id=' +
          row.id +
          '&accessToken=' +
          token
        )
      },
      /***
        * 获取未处理数量
       */
      getQsDealtCount() {
        let that = this
        myHttp
          .getQsDealtCount({
            projectId: this.groupId,
            userId: util.session.get('user').id
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              var data = resp.data.data.dealtCount || []
            }
            that.dealtCount = data
          })
      },
      /**跳转发起*/
      addFlag() {
        this.$router.push({ name: 'startQuestion' })
      },
      // 获取问题列表
      getDictByType() {
        // getDictByType
        var that = this
        myHttp
          .getDictByType({
            type: 'qs_priority'
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.types = resp.data.data.dictList
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
    },
  }
</script>

<style scoped>
  .main {
    height: calc(100% - 10vh);
    /* display: flex; */
  }

  .main-left {
    width: 15vw;
    height: 100%;
    position: relative;
    overflow: auto;
    background: #fff;
    border-radius: 0.5vh;
    padding: 2vh;
  }

  .main-table {
    /* width: calc( 100% - 15vw ); */
    width: 100%;
    height: 100%;
    position: relative;
    padding-left: 1vw;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .build-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 8vh;
    /* border-bottom: 3px solid #f5f5f5; */
    border-top: 1vh solid #ecf0f5;
    border-bottom: 1vh solid #ecf0f5;
  }

  .build-bar span {
    margin-left: 30px;
    margin-right: 20px;
    white-space: nowrap;
    font-weight: bold;
  }

  .build-bar a {
    display: inline-block;
    white-space: nowrap;
    font-size: 17px;
  }

  .build-bar a p {
    display: inline-block;
    margin-left: 10px;
    margin-right: 40px;
  }

  .build-bar>.el-input {
    margin-left: 50px;
    width: 400px;
  }

  .build-bar>.el-button {
    margin-left: 20px;
    background-color: #17b2fe;
    border-color: #17b2fe;
  }

  .build-bar>.el-button+.el-button {
    margin-left: 800px;
  }

  .build-table {
    position: relative;
    width: 100%;
    /* margin: 0 auto; */
    height: calc(100% - 6vh);
    overflow: auto;
    background: #fff;
  }

  .table-item {
    width: 100%;
    height: 22vh;
    position: relative;
    display: flex;
    padding: 1vh;
    border-bottom: 1vh solid #ecf0f5;
  }

  .table-item .item-l {
    width: 11vw;
    height: 100%;
    position: relative;
    margin-left: 50px;
  }

  .table-item .item-r {
    width: 5vh;
    height: 100%;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 1vw;
    margin-right: 50px;
  }

  .table-item .item-mid {
    width: calc(50% - 8vw);
    height: 100%;
    position: relative;
    justify-content: flex-start;
    display: flex;
    flex-wrap: wrap;
    padding-left: 1vw;
  }

  .table-item .item-mid p {
    width: 100%;
    height: 3vh;
    position: relative;
    text-align: left;
    line-height: 3vh;
    color: #737477;
  }

  .el-button-group>.headCur {
    color: #fff;
    background: #17b2fe;
  }

  .head-type {
    color: #17b2fe;
    width: 98px;
    height: 40px;
  }

  .el-button-group>.headCur {
    color: #fff;
    background: #17b2fe;
  }

  .build-bar .on {
    background: #A4C7FD;
    color: #fff;
  }

  .title-crumb {
    display: flex;
    background: #fff;
    height: 9vh;
    margin-bottom: 1vh;
    justify-content: space-between;
  }

  .imgs {
    width: 200px;
    height: 200px;
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  .round {
    position: absolute;
    background: #f00;
    color: #fff;
    border-radius: 50%;
    z-index: 1000;
    padding: 4px;
    left: 88px;
    top: -10px;
    font-size: 10px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .cur{
    color: #f00;
  }
  .img-icon{
    position: absolute;
    width: 5vh;
    height: 5vh;
    top: 0px;
    left: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
<style>
  .qsList .el-tabs {
    width: 100%;
    height: 100%;
    position: relative;
    background: #fff;
  }

  .qsList .el-tabs__header {
    margin: 0;
  }

  .qsList .el-tabs__item {
    width: 5vw;
  }

  .qsList .el-tabs__nav-scroll {
    padding-left: 20px;
  }

  .qsList .el-tabs__content {
    height: calc(100% - 4vh);
  }

  .qsList .el-tab-pane {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .title-crumb span {
    border-bottom: 5px solid transparent;
    padding: 10px;
  }

  .title-crumb .cur {
    color: #358ADA;
    /* border-bottom: 5px solid #358ADA !important; */
  }

  @import '../../assets/css/common.css';
</style>